export const REPLACEABLE_CHARACTERS = {
    "á": "a",
    "ã": "a",
    "â": "a",
    "é": "e",
    "ê": "e",
    "í": "i",
    "ó": "o",
    "ô": "o",
    "ç": "c"
}
